module.exports = __webpack_public_path__ + "img/bg-video-0.bf196c8e.png";